var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{staticClass:"toast-container"},[_c('div',{staticClass:"toast",class:{ visible: _vm.visible },domProps:{"textContent":_vm._s(_vm.message)}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }